<template>
  <div class="w-full">
    <NText variant="caption1" weight="medium">
      {{ t('option.strategyDeleteDialogMessage') }}
    </NText>

    <div class="flex items-center justify-center w-full mt-6">
      <NButton
        class="ml-3 flex-1"
        color="gray"
        variant="flat"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        v-gid="{
          module: 'strategies',
          screen: 'home',
          section: 'strategiesDelete',
          component: 'DeleteStrategiesDialog',
        }"
        color="red"
        class="mr-3 flex-1"
        :loading="loading"
        :disabled="loading"
        @click="emit('delete', isin)"
      >
        {{ t('common.cancelRequest') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';

type TDeleteStrategyDialogEmits = {
  (e: 'delete', isin: string): void;
};

type TDeleteStrategyDialogProps = {
  isin: string;
  loading: boolean;
};

const emit = defineEmits<TDeleteStrategyDialogEmits>();

defineProps<TDeleteStrategyDialogProps>();

const { remove } = useDialog();

const { t } = useI18n();
</script>
